import React, { useEffect, useState } from 'react';
import { getWeatherForecast } from 'services/weatherService';
import { WeatherType } from 'types';
import { toLocalDateString, toLocalDate, fromLocalDate } from 'utils/localTime';
import { getWeatherIcon } from 'utils/weatherutils';

// Define the props type
interface WeatherIconProps {}

const WeatherIcon: React.FC<WeatherIconProps> = () => {
  const [currentWeather, setCurrentWeather] = useState<{
    temperature: string;
    time: string;
    iconType: WeatherType;
  } | null>(null);
  useEffect(() => {
    const fetchWeather = async () => {
      const [year, monthIndex, day, hours] = toLocalDate(new Date());
      const start = fromLocalDate(year, monthIndex, day, hours, 0, 0);
      const stop = new Date(start.getTime() + 3600 * 1000);
      const weatherData = await getWeatherForecast(
        start.toISOString(),
        stop.toISOString()
      );
      if (weatherData.length > 0) {
        const latestWeather = weatherData[weatherData.length - 1];
        setCurrentWeather({
          temperature: `${latestWeather.air_temperature}°F`,
          time: toLocalDateString(start),
          iconType:
            latestWeather.air_temperature > 70
              ? WeatherType.Sunny
              : WeatherType.Cloudy, // Simple logic for iconType
        });
      }
    };
    fetchWeather();
  }, []);

  return (
    <>
      {currentWeather && (
        <>
          <div className="flex flex-col items-end">
            <span className="text-white"> Hour of Weather Forecast: </span>
            <span className="text-white"> {currentWeather.time} </span>
            <span className="text-white"> Forecast Temperature: </span>
            <span className="text-4xl text-white"> {currentWeather.temperature} </span>
          </div>
          <div className="weather-icon">
            {getWeatherIcon(currentWeather.iconType)}
          </div>
        </>
      )}
    </>
  );
};

export default WeatherIcon;
